import stbApiGateway from '@/services/stbApiGateway';

export const syncExcursion = async ({ state }, { id, excursionData, oauthSignature }) => {
  const stbApi = stbApiGateway(state.axios);
  const response = await stbApi.syncExcursions(id, excursionData, oauthSignature);
  return response;
};
